import React from "react"

export default function Progress(props) {
  return <div className="heading">{""}</div>
}
